import { IModelValidationsAccessor } from "../../IFormModelAccessor";

import { ICustomValidationErrorManagerProxy } from "./ICustomValidationFunctionCallContext";

export class CustomValidationErrorManagerProxy implements ICustomValidationErrorManagerProxy {
    readonly #modelAccessor: IModelValidationsAccessor;

    public constructor(modelAccessor: IModelValidationsAccessor) {
        this.#modelAccessor = modelAccessor;
    }

    public addError(nodePath: string, message: string): void {
        this.#modelAccessor.addError(nodePath, message);
    }

    public addErrorCached(nodePath: string, message: string): void {
        this.#modelAccessor.addError(nodePath, message);
    }

    public addWarning(nodePath: string, message: string): void {
        this.#modelAccessor.addWarning(nodePath, message);
    }

    public clearWarnings(nodePath: string): void {
        this.#modelAccessor.clearWarnings(nodePath);
    }

    public clearErrors(nodePath: string): void {
        this.#modelAccessor.clearErrors(nodePath);
    }

    public removeWarning(nodePath: string, message: string): void {
        this.#modelAccessor.removeWarning(nodePath, message);
    }
}
